import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaViewerComponent } from './media-viewer.component';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { AvatarModule } from 'primeng/avatar';
import { PipeModule } from '../../pipe.module';

@NgModule({
  declarations: [MediaViewerComponent],
  imports: [
    CommonModule,
    ButtonModule,
    RippleModule,
    TooltipModule,
    DialogModule,
    AvatarModule,
    PipeModule,
  ],
  exports: [MediaViewerComponent],
})
export class MediaViewerModule {}
